import React, {Component} from 'react';
import {connect} from 'react-redux';
import Title from '../base/title';
import Cta from '../base/cta';
import api from '../../utils/api';
import Modal from '../base/modal';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Strategy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: true,
            loader: ' loader-box',
            strategy: {},
            readonly: true,
            modalVisible: false
        };
        this.save = this.save.bind(this);
        this.inherit = this.inherit.bind(this);
    }

    componentDidMount() {
        let _self = this;
        let _strategy = {};
        let readonly = true;
        api.get('product_strategies/?type=' + this.props.level + '&id=' + this.props.data.id).then(resp => {
            resp.data.forEach(strategy => {
                if (strategy.type === 'CLUSTER') readonly = false;
                if (!_strategy[strategy.product.short_name]) _strategy[strategy.product.short_name] = {
                    COUNTRY: {value: '', product: '', id: ''},
                    CLUSTER: {value: '', product: '', id: ''}
                };
                _strategy[strategy.product.short_name][strategy.type] = {
                    value: strategy.difference,
                    product: strategy.product.id,
                    id: strategy.id
                };
            });
            Object.keys(_strategy).forEach(key => {
                if (_strategy[key].CLUSTER.id === '' && _strategy[key]['COUNTRY']) {
                    _strategy[key].CLUSTER.value = _strategy[key].COUNTRY.value;
                    _strategy[key].CLUSTER.product = _strategy[key].COUNTRY.product;
                }
            });
            _self.setState({strategy: _strategy, readonly: readonly, loader: ''});
        });
    }

    inherit() {
        let _self = this;
        let promises = [];
        let _strategy = JSON.parse(JSON.stringify(this.state.strategy));
        Object.keys(_strategy).forEach(key => {
            if (_strategy[key].CLUSTER.id !== '') {
                promises.push(new Promise((a, r) => {
                    api.delete('product_strategies/id/' + _strategy[key].CLUSTER.id).then(resp => {
                        _strategy[key].CLUSTER.id = '';
                        _strategy[key].CLUSTER.value = _strategy[key].COUNTRY.value;
                        a(resp.data);
                    });
                }));
            }
        });
        Promise.all(promises).then(data => {
            _self.setState({
                strategy: _strategy,
                readonly: true
            })
        });
    }

    save(confirm) {
        if (confirm) {
            let _self = this;
            let promises = [];
            let _strategy = JSON.parse(JSON.stringify(this.state.strategy));
            Object.keys(_strategy).forEach(key => {
                if (_strategy[key].CLUSTER.id === '') {
                    promises.push(new Promise((a, r) => {
                        api.post('product_strategies', {
                            pricing_cluster: _self.props.data.id,
                            product: _strategy[key].CLUSTER.product,
                            difference: _strategy[key].CLUSTER.value
                        }).then(resp => {
                            _strategy[key].CLUSTER.id = resp.data.id;
                            a(resp.data);
                        });
                    }));
                } else {
                    promises.push(new Promise((a, r) => {
                        api.put('product_strategies/id/' + _strategy[key].CLUSTER.id, {
                            difference: _strategy[key].CLUSTER.value
                        }).then(resp => {
                            toast.success(key + ' actualizado!');
                            a(resp.data);
                        }).catch(error => {
                            Object.keys(error.response.data).forEach(eKey => {
                                error.response.data[eKey].forEach(msg => {
                                    toast.error(key + ': ' + msg);
                                })
                            });
                        });
                    }));
                }
            });
            Promise.all(promises).then(data => {
                _self.setState({strategy: _strategy})
            });
        } else {
            this.refs.modal.show();
        }
    }

    render() {
        let _self = this;
        let _user = _self.props.user;

        let cancel = {
            text: 'CANCELAR',
            click: () => {
                this.refs.modal.hide();
            }
        };

        let confirm = {
            text: 'CONFIRMAR',
            click: () => {
                this.save(true);
                this.refs.modal.hide();
            }
        };

        return <div className="row">
            <ToastContainer/>
            <Title isOpen={_self.state.opened} toggle={() => {
                _self.setState({strategy: {}, opened: !_self.state.opened}, function () {
                    if (_self.state.opened) _self.componentDidMount();
                });
            }} edit={{
                onClick: () => {
                    _self.setState({readonly: false});
                }, icon: 'fas fa-pencil-alt', label: 'EDITAR ESTRATEGIA'
            }} text="ESTRATEGIA" isGray={true} hasIcon={true}/>
            {_self.state.opened && <div className="row">
                <div className="col s12">
                    <div className="row">
                        <div className={"marketShare" + this.state.loader}>
                            <table className='c-table strategy'>
                                <thead className="no-border">
                                <tr>
                                    <td className="border-bottom">&nbsp;</td>
                                    {Object.keys(_self.state.strategy).map((key) =>
                                        <td className="border-bottom center" key={key}>{key}</td>
                                    )}
                                    <td></td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr className="bordeable">
                                    <td>Diferencial País (%)</td>
                                    {Object.keys(_self.state.strategy).map((key) =>
                                        <td key={key}><input readOnly="readonly" type="number"
                                                             value={_self.state.strategy[key].COUNTRY.value}/></td>
                                    )}
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Diferencial Cluster (%)</td>
                                    {Object.keys(_self.state.strategy).map((key) =>
                                        <td key={key}><input readOnly={_self.state.readonly} type="number"
                                                             value={_self.state.strategy[key].CLUSTER.value}
                                                             onChange={ev => {
                                                                 _self.state.strategy[key].CLUSTER.value = ev.target.value;
                                                                 _self.setState(_self.state)
                                                             }}/></td>
                                    )}
                                    {_user.canDefineStrategy ?
                                        <td>
                                            <div className="c-switch">
                                                <span onClick={this.inherit}
                                                      className={'c-switch-label'}>Heredado</span>
                                                <div onClick={() => {
                                                    _self.state.readonly ? _self.setState({readonly: false}) : _self.inherit();
                                                }} className="c-switch-toggler"><i
                                                    className={_self.state.readonly ? '' : 'active'}></i></div>
                                                <span onClick={() => {
                                                    _self.setState({readonly: false});
                                                }}
                                                      className={'c-switch-label ' + (_self.state.readonly ? '' : 'active')}>Manual</span>
                                            </div>
                                        </td> : <td></td>}
                                </tr>
                                {_user.canDefineStrategy ? !_self.state.readonly &&
                                    <tr>
                                        <td colSpan="6" className="centered">
                                            <Cta text="CANCELAR" light centered className="medium mr-3"
                                                 click={this.inherit}/>
                                            <Cta text="GUARDAR CAMBIOS" centered className="medium"
                                                 click={() => this.save(false)}/>
                                        </td>
                                    </tr> : <tr>
                                    <td></td>
                                </tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>}
            <Modal ref="modal" visible={this.state.modalVisible}
                   title={"Edición de Estrategia"}
                   save={confirm} cancel={cancel}>
                <p>¿Realmente desea editar la estrategia?</p>
            </Modal>
        </div>
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Strategy);


// WEBPACK FOOTER //
// ./src/containers/analisis/editablestrategy.js